var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ALTCHA_HEADER } from "./Recek/altcha/AltchaWidget";
/** Error code of a request rejected for a missing/invalid/replayed captcha (HTTP 400, DB-876). */
export var CAPTCHA_INVALID_CODE = "CAPTCHA_INVALID";
/** Anonymous mod-br-publishers captcha challenge of the registration form (DB-876). */
export var REGISTRATION_CAPTCHA_PATH = "publishers/registration/captcha/challenge";
/** Shortest (trimmed) address fragment the suggest endpoint accepts; shorter ones are not sent. */
export var ADDRESS_SUGGEST_MIN_LENGTH = 3;
var ADDRESS_SUGGEST_LIMIT = 10;
var HTTP_NOT_FOUND = 404;
var HTTP_BAD_REQUEST = 400;
var HTTP_TOO_MANY_REQUESTS = 429;
var NO_CACHE_HEADERS = {
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
};
var responseOf = function (error) {
    return error === null || error === void 0 ? void 0 : error.response;
};
/** HTTP status of a failed ky request, undefined for a network/other failure. */
export var getResponseStatus = function (error) { var _a; return (_a = responseOf(error)) === null || _a === void 0 ? void 0 : _a.status; };
/** The server (or the gateway) rate-limited the request. */
export var isTooManyRequestsError = function (error) {
    return getResponseStatus(error) === HTTP_TOO_MANY_REQUESTS;
};
/** The server rejected the request's captcha (HTTP 400 + CAPTCHA_INVALID, either error shape). */
export var isCaptchaInvalidError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var response, readable, body, _a;
    var _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                response = responseOf(error);
                if ((response === null || response === void 0 ? void 0 : response.status) !== HTTP_BAD_REQUEST) {
                    return [2 /*return*/, false];
                }
                _g.label = 1;
            case 1:
                _g.trys.push([1, 3, , 4]);
                readable = typeof response.clone === "function" ? response.clone() : response;
                return [4 /*yield*/, ((_b = readable.json) === null || _b === void 0 ? void 0 : _b.call(readable))];
            case 2:
                body = (_g.sent());
                return [2 /*return*/, ((_e = (_d = (_c = body === null || body === void 0 ? void 0 : body.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : (_f = body === null || body === void 0 ? void 0 : body.error) === null || _f === void 0 ? void 0 : _f.code) === CAPTCHA_INVALID_CODE];
            case 3:
                _a = _g.sent();
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Submits the anonymous publisher registration. The solved captcha travels in the
 * {@link ALTCHA_HEADER} header; it is single-use, so a failed submit needs a new one.
 */
export var createPublisherRegistration = function (ky, publisherData, captchaPayload) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, ky.post("publishers/registration", {
                    json: publisherData,
                    headers: (_a = {
                            "Content-Type": "application/json",
                            Pragma: "no-cache",
                            Expires: "0"
                        },
                        _a[ALTCHA_HEADER] = captchaPayload,
                        _a),
                })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
/**
 * Suggests RÚIAN addresses for a typed fragment. Fragments shorter than
 * {@link ADDRESS_SUGGEST_MIN_LENGTH} are not sent, "nothing found" (404) is an empty list and a
 * rate limit (429) is reported instead of thrown; any other failure is rethrown.
 */
export var fetchAddressSuggestions = function (ky, query) { return __awaiter(void 0, void 0, void 0, function () {
    var address, response, data, error_1, status_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                address = (query !== null && query !== void 0 ? query : "").trim();
                if (address.length < ADDRESS_SUGGEST_MIN_LENGTH) {
                    return [2 /*return*/, { addresses: [], rateLimited: false }];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, ky.get("publisher-address/registration/suggest", {
                        searchParams: { address: address, limit: ADDRESS_SUGGEST_LIMIT },
                        headers: NO_CACHE_HEADERS,
                    })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                data = (_b.sent());
                return [2 /*return*/, { addresses: (_a = data === null || data === void 0 ? void 0 : data.publisherAddresses) !== null && _a !== void 0 ? _a : [], rateLimited: false }];
            case 4:
                error_1 = _b.sent();
                status_1 = getResponseStatus(error_1);
                if (status_1 === HTTP_NOT_FOUND) {
                    return [2 /*return*/, { addresses: [], rateLimited: false }];
                }
                if (status_1 === HTTP_TOO_MANY_REQUESTS) {
                    return [2 /*return*/, { addresses: [], rateLimited: true }];
                }
                throw error_1;
            case 5: return [2 /*return*/];
        }
    });
}); };
